<template>
    <div class="flex h-full flex-col overflow-y-scroll bg-white shadow-xl">
        <div class="flex-1 overflow-y-auto px-4 py-6 sm:px-6">
          <div class="flex items-start justify-between">
            <DialogTitle class="text-lg font-medium text-gray-900">Winkelmandje</DialogTitle>
            <div class="ml-3 flex h-7 items-center">
              <button type="button" class="relative -m-2 p-2 text-gray-400 hover:text-gray-500" @click="close">
                <span class="absolute -inset-0.5" />
                <span class="sr-only">Sluit paneel</span>
                <XMarkIcon class="size-6" aria-hidden="true" />
              </button>
            </div>
          </div>
          <div class="mt-8">
            <div class="flow-root">
              <ul role="list" class="-my-6 divide-y divide-gray-200">
              
               <!-- <li v-for="(product, productIdx) in products" :key="product.id" class="flex py-6"> -->
                  <CartItem  v-for="cartItem in cartItemList" :key="cartItem.id" :cartItem="cartItem" :cartView="false" />
              </ul>
            </div>
          </div>
        </div>
        <div class="border-t border-gray-200 px-4 py-6 sm:px-6">
          <div class="flex justify-between text-base font-medium text-gray-900">
            <p>Totaal</p>
            <p>{{ $filters.toCurrency(cartValue) }}</p>
          </div>
          <div class="mt-6">
            <a href="/checkout" @click.prevent="saveShoppingCartForOrder()"  class="flex items-center justify-center rounded-md border border-transparent bg-primary-blue px-6 py-3 text-base font-medium text-white shadow-sm hover:bg-indigo-700">Bestellen</a>
          </div>
          <div class="mt-6 flex justify-center text-center text-sm text-gray-500">
            <p>
              of{{ ' ' }}
              <button type="button" class="font-medium text-primary-blue hover:text-gray-600" @click="saveShoppingCartLocal()">
                verder winkelen
                <span aria-hidden="true"> &rarr;</span>
              </button>
            </p>
          </div>
        </div>
      </div>
</template>
<script>
  import { DialogTitle } from '@headlessui/vue'
  import { XMarkIcon } from '@heroicons/vue/24/outline'
  import { mapActions, mapGetters } from 'vuex'
  import CartItem from "./CartItem";
  //import router from "@/router";

export default {
    name: 'Shop Cart',
    components: { DialogTitle, XMarkIcon, CartItem },
    computed: {
      ...mapGetters([
      'cartItemList',
      'isLoggedIn',
      'currentUser',
      'cartValue',
    ]),
    },
    methods: {
      ...mapActions([
      'saveShoppingCart',
      'saveToTransaction',
      'clearCart',
      ]),
      saveShoppingCartForOrder() {
        if (this.isLoggedIn) {
          this.saveShoppingCart({
            cartItemList: this.cartItemList,
            uid: this.currentUser.uid,
            totalAmount: this.cartValue,
          }).then(() => {
            this.$gtag.event('cart', { 'event_category': 'cart', 'event_label': 'bestellen', 'value':  this.cartValue });
              this.$router.push('/checkout');
          });
        }
      },
      saveShoppingCartLocal() {
        console.log(this.isLoggedIn);
      if (this.isLoggedIn) {
          this.saveShoppingCart({
            cartItemList: this.cartItemList,
            uid: this.currentUser.uid,
            totalAmount: this.cartValue,
          }).then(() => {
            this.$gtag.event('cart', { 'event_category': 'cart', 'event_label': 'verder winkelen', 'value':  this.cartValue });
            console.log("save cart")
            /*
            this.addMessage({
              messageClass: 'success',
              message: 'Your shopping cart is saved successfully',
            })*/
            this.$router.push(this.$route.path);
          })
        } else {
          /*
          this.addMessage({
            messageClass: 'danger',
            message: message,
          })
            */
        }
      },
        close() {
            this.saveShoppingCartLocal()
            this.$router.push(this.$route.path);
        },
    } 
};
</script>